module.exports = __webpack_public_path__ + "static/media/chrome_logo.f3b6c54c.svg";